import { getToolsProjects } from "../api/toolProjectsHttpClient";

export const useToolsProjectsGrid = () => {
  return { fetchGridData: getToolsProjects };
};
